import { Form, Input, Select, Row, Col } from "antd";
import { UserOutlined, MailOutlined, IdcardOutlined, TeamOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { esEmailValido } from "../../../../utils/esEmailValido";
import { normalizarBusqueda } from "../../shared/normalizarBusqueda";

const { Option } = Select;

export const DatosServicio = ({ handleInputChange, handleSelectChange }) => {
  const { captura } = useSelector((state) => state.asistenciasReducer);
  const emailInvalido = Boolean(captura.email && !esEmailValido(captura.email));

  return (
    <Form layout="vertical" size="large">
      <Row gutter={12}>
        <Col xs={24} sm={8}>
          <Form.Item label="Nombre Beneficiario">
            <Input
              prefix={<UserOutlined />}
              placeholder="Nombre Beneficiario"
              value={captura.nombreBeneficiario || ""}
              onChange={handleInputChange("nombreBeneficiario")}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item label="Apellido Paterno Beneficiario">
            <Input
              prefix={<UserOutlined />}
              placeholder="Apellido Paterno"
              value={captura.apellidoPaternoBeneficiario || ""}
              onChange={handleInputChange("apellidoPaternoBeneficiario")}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item label="Apellido Materno Beneficiario">
            <Input
              prefix={<UserOutlined />}
              placeholder="Apellido Materno"
              value={captura.apellidoMaternoBeneficiario || ""}
              onChange={handleInputChange("apellidoMaternoBeneficiario")}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item
            label="Email"
            validateStatus={emailInvalido ? "error" : ""}
            help={emailInvalido ? "Debe tener formato de correo electrónico" : ""}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="Email"
              type="email"
              value={captura.email || ""}
              onChange={handleInputChange("email")}
              status={emailInvalido ? "error" : ""}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item label="Tipo de Persona">
            <Select
              placeholder="Seleccione"
              value={captura.tipoPersona || undefined}
              onChange={handleSelectChange("tipoPersona")}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                normalizarBusqueda(option?.children).includes(normalizarBusqueda(input))
              }
            >
              <Option value="Asegurado">Asegurado</Option>
              <Option value="Beneficiario">Beneficiario</Option>
              <Option value="Ajustador">Ajustador</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={12}>
        <Col xs={24} sm={8}>
          <Form.Item label="Validador 2">
            <Input
              prefix={<IdcardOutlined />}
              placeholder="Validador 2"
              value={captura.validador2 || ""}
              onChange={handleInputChange("validador2")}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item label="Agente">
            <Input
              prefix={<TeamOutlined />}
              placeholder="Agente"
              value={captura.agente || ""}
              onChange={handleInputChange("agente")}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
